function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_49",
  "data-name": "Group 49",
  transform: "translate(1354.554 -8001.573)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_120",
  "data-name": "Path 120",
  d: "M-1300.8,8018.427h21.365v26.3",
  transform: "translate(16 4.692)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_121",
  "data-name": "Path 121",
  d: "M-1304.174,8090.009h-21.365v-26.3",
  transform: "translate(8.417 18.571)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_47",
  "data-name": "Group 47",
  transform: "translate(-1353.005 8003.123)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  width: 54.511,
  height: 67.822,
  rx: 2.711,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3.099
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_6",
  "data-name": "Line 6",
  y2: 67.822,
  transform: "translate(11.388)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.937
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_46",
  "data-name": "Group 46",
  transform: "translate(15.812 8.26)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_122",
  "data-name": "Path 122",
  d: "M-1308.384,8018.879h-31.946a.329.329,0,0,0-.363.277v2.783a.329.329,0,0,0,.363.276h31.946a.328.328,0,0,0,.362-.276v-2.783A.328.328,0,0,0-1308.384,8018.879Z",
  transform: "translate(1340.966 -8006.553)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_123",
  "data-name": "Path 123",
  d: "M-1340.33,8009.445a.329.329,0,0,0-.363.277v2.782a.329.329,0,0,0,.363.277h26.283v-3.337Z",
  transform: "translate(1340.966 -8009.445)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_124",
  "data-name": "Path 124",
  d: "M-1315.148,8009.445h-3.473v3.337h3.473a.329.329,0,0,0,.362-.277v-2.782A.328.328,0,0,0-1315.148,8009.445Z",
  transform: "translate(1347.731 -8009.445)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_125",
  "data-name": "Path 125",
  d: "M-1340.433,8017.5h22.84a.269.269,0,0,0,.259-.276v-2.783a.268.268,0,0,0-.259-.276h-22.84a.268.268,0,0,0-.26.276v2.783A.269.269,0,0,0-1340.433,8017.5Z",
  transform: "translate(1340.966 -8007.999)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_126",
  "data-name": "Path 126",
  d: "M-1340.671,8036.263h20.429a.259.259,0,0,0,.232-.277V8033.2a.258.258,0,0,0-.232-.276h-20.429a.257.257,0,0,0-.231.276v2.784A.258.258,0,0,0-1340.671,8036.263Z",
  transform: "translate(1340.902 -8002.248)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_127",
  "data-name": "Path 127",
  d: "M-1308.594,8023.492h-31.946a.328.328,0,0,0-.362.276v2.783a.327.327,0,0,0,.362.276h31.946a.329.329,0,0,0,.363-.276v-2.783A.33.33,0,0,0-1308.594,8023.492Z",
  transform: "translate(1340.902 -8005.14)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_128",
  "data-name": "Path 128",
  d: "M-1340.54,8028.209a.329.329,0,0,0-.362.277v2.782a.328.328,0,0,0,.362.277h1.9v-3.337Z",
  transform: "translate(1340.902 -8003.694)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_129",
  "data-name": "Path 129",
  d: "M-1309.64,8028.209h-27.85v3.337h27.85a.329.329,0,0,0,.363-.277v-2.782A.33.33,0,0,0-1309.64,8028.209Z",
  transform: "translate(1341.948 -8003.694)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_130",
  "data-name": "Path 130",
  d: "M-1308.594,8047.183h-31.946a.327.327,0,0,0-.362.276v2.783a.328.328,0,0,0,.362.276h31.946a.33.33,0,0,0,.363-.276v-2.783A.329.329,0,0,0-1308.594,8047.183Z",
  transform: "translate(1340.902 -7997.878)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_131",
  "data-name": "Path 131",
  d: "M-1308.594,8037.749h-31.946a.329.329,0,0,0-.362.275v2.784a.327.327,0,0,0,.362.275h31.946a.328.328,0,0,0,.363-.275v-2.784A.33.33,0,0,0-1308.594,8037.749Z",
  transform: "translate(1340.902 -8000.77)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_132",
  "data-name": "Path 132",
  d: "M-1311.053,8042.465h-21.823v3.336h21.823a.329.329,0,0,0,.363-.275v-2.784A.329.329,0,0,0-1311.053,8042.465Z",
  transform: "translate(1343.361 -7999.324)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_133",
  "data-name": "Path 133",
  d: "M-1340.54,8042.465a.328.328,0,0,0-.362.276v2.784a.327.327,0,0,0,.362.275h5.192v-3.336Z",
  transform: "translate(1340.902 -7999.324)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_6",
  "data-name": "Ellipse 6",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(4.383 5.478)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7",
  "data-name": "Ellipse 7",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(4.383 11.322)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_8",
  "data-name": "Ellipse 8",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(4.383 17.165)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(4.383 23.009)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(4.383 28.852)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_11",
  "data-name": "Ellipse 11",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(4.383 34.696)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_12",
  "data-name": "Ellipse 12",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(4.383 40.539)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_13",
  "data-name": "Ellipse 13",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(4.383 46.383)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_14",
  "data-name": "Ellipse 14",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(4.383 52.226)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_15",
  "data-name": "Ellipse 15",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(4.383 58.07)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_48",
  "data-name": "Group 48",
  transform: "translate(-1281.515 8060.563)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_17",
  "data-name": "Rectangle 17",
  width: 54.511,
  height: 67.822,
  rx: 2.711,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 3.099
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_7",
  "data-name": "Line 7",
  x1: 53.446,
  transform: "translate(1.065 10.583)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.937
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_134",
  "data-name": "Path 134",
  d: "M-1276.669,8091.124h20.35a.256.256,0,0,0,.23-.275v-2.784a.255.255,0,0,0-.23-.275h-20.35a.255.255,0,0,0-.231.275v2.784A.256.256,0,0,0-1276.669,8091.124Z",
  transform: "translate(1304.84 -8034.614)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_135",
  "data-name": "Path 135",
  d: "M-1276.584,8086.791h20.126a.256.256,0,0,0,.229-.277v-2.782a.256.256,0,0,0-.229-.277h-20.126a.257.257,0,0,0-.229.277v2.782A.257.257,0,0,0-1276.584,8086.791Z",
  transform: "translate(1304.867 -8035.941)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_136",
  "data-name": "Path 136",
  d: "M-1276.6,8095.458h20.18a.256.256,0,0,0,.229-.277V8092.4a.255.255,0,0,0-.229-.276h-20.18a.256.256,0,0,0-.23.276v2.782A.257.257,0,0,0-1276.6,8095.458Z",
  transform: "translate(1304.86 -8033.286)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_137",
  "data-name": "Path 137",
  d: "M-1292.164,8074.062h39.628c.248,0,.449-.5.449-1.113v-11.215c0-.614-.2-1.113-.449-1.113h-39.628c-.248,0-.451.5-.451,1.113v11.215C-1292.615,8073.563-1292.412,8074.062-1292.164,8074.062Z",
  transform: "translate(1300.024 -8042.94)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1.937
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_138",
  "data-name": "Path 138",
  d: "M-1292.728,8099.231h14.811a5.843,5.843,0,0,0,.167-1.956v-19.7a5.852,5.852,0,0,0-.167-1.956h-14.811a5.852,5.852,0,0,0-.167,1.956v19.7A5.843,5.843,0,0,0-1292.728,8099.231Z",
  transform: "translate(1299.938 -8038.342)",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1.937
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_139",
  "data-name": "Path 139",
  d: "M-1276.532,8082.458h19.988a.256.256,0,0,0,.227-.276V8079.4a.255.255,0,0,0-.227-.276h-19.988a.254.254,0,0,0-.226.276v2.783A.255.255,0,0,0-1276.532,8082.458Z",
  transform: "translate(1304.884 -8037.271)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_140",
  "data-name": "Path 140",
  d: "M-1276.532,8078.124h19.988a.255.255,0,0,0,.227-.275v-2.784a.254.254,0,0,0-.227-.275h-19.988a.253.253,0,0,0-.226.275v2.784A.255.255,0,0,0-1276.532,8078.124Z",
  transform: "translate(1304.884 -8038.599)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_16",
  "data-name": "Ellipse 16",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(12.876 3.916)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_17",
  "data-name": "Ellipse 17",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(8.383 3.916)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_18",
  "data-name": "Ellipse 18",
  cx: 1.643,
  cy: 1.643,
  r: 1.643,
  transform: "translate(3.889 4.002)",
  fill: "#fff"
})));

var SvgSageIcon1 = function SvgSageIcon1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129.099,
    height: 128.361,
    viewBox: "0 0 129.099 128.361",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSageIcon1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sageIcon1.26947104.svg";
export { ForwardRef as ReactComponent };